import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  public emitSubjet = new Subject<any>();
  dataEmitted = this.emitSubjet.asObservable();

  constructor() { }

  emit(data: any) {
    this.emitSubjet.next(data);
  }
}
